module.exports = __webpack_public_path__ + "img/exch_logo1.png";